"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DriftCardOverrides = {
    DriftCard: {
        styleOverrides: {
            root: ({ theme }) => ({
                padding: theme.spacing(2),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                color: theme.palette.gray[700],
                fontSize: '14px',
                lineHeight: '20px',
                '&:hover': {
                    backgroundColor: '#F9F9F9',
                },
                transition: 'background-color 0.3s ease',
            }),
            title: ({ theme }) => ({
                lineHeight: '24px',
                marginBottom: theme.spacing(1),
                color: theme.palette.gray[900],
                fontSize: theme.typography.fontSize,
                fontWeight: theme.typography.fontWeightBold,
                alignItems: 'center',
            }),
            rightAdornment: ({ theme }) => ({
                display: 'flex',
                alignItems: 'center',
                marginLeft: theme.spacing(1),
            }),
        },
        defaultProps: {
            square: false,
            variant: 'outlined',
            elevation: 0,
        },
    },
};
exports.default = DriftCardOverrides;
//# sourceMappingURL=DriftCardOverrides.js.map